import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { getMeetingScoresProgress } from "../api/meeting-api";
import type { ScoringProgress } from "../types/meeting.type";

const STALE_TIME = 30_000;

export const meetingScoresProgressKeys = {
  progress: (rfxId: number, evalId: number) =>
    ["meetingScoresProgress", rfxId, evalId] as const,
};

export const useMeetingScoresProgress = (
  rfxId: number | undefined,
  evalId: number | undefined
): UseQueryResult<ScoringProgress> => {
  return useQuery({
    queryKey: meetingScoresProgressKeys.progress(rfxId!, evalId!),
    queryFn: () => getMeetingScoresProgress(rfxId!, evalId!),
    enabled: !!rfxId && !!evalId,
    staleTime: STALE_TIME,
  });
};
